(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_7cf32ed"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('metapets-felicia')) {
    class MetaPetsFelicia extends HTMLElement {
      static vendorPromise;

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.entry = this.querySelector('[data-assistant-entry]');
        this.button = this.querySelector('[data-assistant-open]');
        this.label = this.querySelector('[data-assistant-label]');
        this.status = this.querySelector('[data-assistant-status]');
        this.message = this.querySelector('[data-assistant-message]');
        this.contact = this.querySelector('[data-assistant-contact]');
        this.host = this.querySelector('[data-assistant-host]');
        this.entry.hidden = false;
        this.button.addEventListener('click', () => this.open());
      }

      static loadVendor() {
        if (customElements.get('elevenlabs-convai')) return Promise.resolve();
        if (this.vendorPromise) return this.vendorPromise;
        this.vendorPromise = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://unpkg.com/@elevenlabs/convai-widget-embed@beta';
          script.async = true;
          script.dataset.metapetsAssistant = 'true';
          const timeout = setTimeout(() => {
            script.remove();
            reject(new Error('Assistant loading timed out'));
          }, 20000);
          script.addEventListener('error', () => {
            clearTimeout(timeout);
            script.remove();
            reject(new Error('Assistant could not load'));
          }, { once: true });
          customElements.whenDefined('elevenlabs-convai').then(() => {
            clearTimeout(timeout);
            resolve();
          });
          document.head.append(script);
        }).catch((error) => {
          this.vendorPromise = null;
          throw error;
        });
        return this.vendorPromise;
      }

      waitForControl(widget) {
        return new Promise((resolve, reject) => {
          let observer;
          let frame;
          const finish = (control, error) => {
            clearTimeout(timeout);
            cancelAnimationFrame(frame);
            observer?.disconnect();
            if (error) reject(error);
            else resolve(control);
          };
          const inspect = () => {
            if (!this.isConnected) {
              finish(null, new Error('Assistant removed'));
              return;
            }
            const root = widget.shadowRoot;
            if (!root) {
              frame = requestAnimationFrame(inspect);
              return;
            }
            const control = Array.from(root.querySelectorAll('button')).find((button) => !button.disabled && button.getClientRects().length);
            if (control) {
              finish(control);
              return;
            }
            if (!observer) {
              observer = new MutationObserver(inspect);
              observer.observe(root, { childList: true, subtree: true, attributes: true });
            }
          };
          const timeout = setTimeout(() => finish(null, new Error('Assistant is unavailable')), 20000);
          inspect();
        });
      }

      async open() {
        if (this.button.disabled) return;
        let focusMovedAway = false;
        const trackFocus = (event) => {
          if (event.target !== this.button && event.target !== document.body) focusMovedAway = true;
        };
        const mayMoveFocus = () => !focusMovedAway && (document.activeElement === this.button || document.activeElement === document.body);
        document.addEventListener('focusin', trackFocus);
        this.button.disabled = true;
        this.host.setAttribute('aria-busy', 'true');
        this.label.textContent = this.dataset.loading;
        this.status.textContent = this.dataset.loading;
        this.message.textContent = '';
        this.contact.hidden = true;
        this.host.replaceChildren(this.querySelector('template').content.cloneNode(true));
        try {
          await MetaPetsFelicia.loadVendor();
          const control = await this.waitForControl(this.host.querySelector('elevenlabs-convai'));
          if (!this.isConnected) return;
          const moveFocus = mayMoveFocus();
          this.entry.hidden = true;
          this.status.textContent = this.dataset.ready;
          if (moveFocus) control.focus({ preventScroll: true });
        } catch (error) {
          if (!this.isConnected) return;
          const moveFocus = mayMoveFocus();
          this.host.replaceChildren();
          this.button.disabled = false;
          this.label.textContent = this.dataset.retry;
          this.message.textContent = this.dataset.unavailable;
          this.status.textContent = this.dataset.unavailable;
          this.contact.hidden = false;
          if (moveFocus) this.button.focus({ preventScroll: true });
        } finally {
          document.removeEventListener('focusin', trackFocus);
          this.host.removeAttribute('aria-busy');
        }
      }
    }
    customElements.define('metapets-felicia', MetaPetsFelicia);
  }
  } catch(e) { console.error(e); }
})();

})();
